'use strict';

var _ = require('lodash');
var ChartPricingDepartureDatesLegendController = function ChartPricingDepartureDatesLegendController($scope, $rootScope, legendFilterService) {
  $scope.directionItems = [createDirectionItem('OUTBOUND'), createDirectionItem('INBOUND')];
  $scope.selectedDirectionItem = createDirectionItem('OUTBOUND');
  $scope.reloadFilters = function () {
    $scope.marketLabels = legendFilterService.getMarkets();
    $scope.posLabels = legendFilterService.getPoses(legendFilterService.getSelectedMarket());
    $scope.cabinLabels = legendFilterService.getCabins(legendFilterService.getSelectedMarket(), legendFilterService.getSelectedPos());
    $scope.selectedMarket = legendFilterService.getSelectedMarket();
    $scope.selectedPOS = legendFilterService.getSelectedPos();
    $scope.selectedCabin = legendFilterService.getSelectedCabin();
    $scope.selectedDirectionItem = createDirectionItem(legendFilterService.getSelectedDirection());
  };
  $scope.isLegendVisible = function () {
    return _.size($scope.marketLabels) && _.size($scope.posLabels) && _.size($scope.cabinLabels);
  };
  $scope.$watch('selectedMarket', function (newValue, oldValue) {
    if (newValue !== oldValue && newValue !== legendFilterService.getSelectedMarket()) {
      legendFilterService.setSelectedMarket(newValue);
      $scope.posLabels = legendFilterService.getPoses(legendFilterService.getSelectedMarket());
      $scope.selectedPOS = '';
    }
  });
  $scope.$watch('selectedPOS', function (newValue, oldValue) {
    if (newValue !== oldValue && newValue !== legendFilterService.getSelectedPos()) {
      legendFilterService.setSelectedPos(newValue);
      $scope.selectedPOS = legendFilterService.getSelectedPos();
      $scope.cabinLabels = legendFilterService.getCabins(legendFilterService.getSelectedMarket(), legendFilterService.getSelectedPos());
      $scope.emitReloadChart();
    }
  });
  $scope.$watch('selectedCabin', function (newValue, oldValue) {
    if (newValue !== oldValue && newValue !== legendFilterService.getSelectedCabin()) {
      legendFilterService.setSelectedCabin(newValue);
      $scope.selectedCabin = legendFilterService.getSelectedCabin();
    }
    $scope.emitReloadChart();
  });
  $scope.$watch('selectedDirectionItem', function (newValue, oldValue) {
    if (newValue.value !== oldValue.value && newValue.value !== legendFilterService.getSelectedDirection()) {
      legendFilterService.setSelectedDirection(newValue.value);
      $scope.emitReloadChart();
    }
  });
  $scope.resetChartHandler = function () {
    $rootScope.$broadcast('chart:DepartureDate:reset');
  };
  $scope.emitReloadChart = function () {
    $rootScope.$broadcast('chart:DepartureDate:filterUpdate');
  };
  function createDirectionItem(directionValue) {
    var directionLabel = _.chain(directionValue).lowerCase().upperFirst().value();
    return {
      label: directionLabel,
      value: directionValue
    };
  }
};
ChartPricingDepartureDatesLegendController.$inject = ['$scope', '$rootScope', 'PricingDepartureDatesLegendFilterService'];
module.exports = ChartPricingDepartureDatesLegendController;